import React, { FC } from 'react'
import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import useStyles from './account-card-styles'

interface AccountCardProps {
  member: TMember
  onSelect: (memberId: string) => void
}

const AccountCard: FC<AccountCardProps> = ({ member, onSelect }) => {
  const { classes } = useStyles()
  const { office, memberMlsId } = member

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <Typography variant="h6" className={classes.officeName}>
          {office.officeName}
        </Typography>
        <Typography variant="body2" className={classes.ids}>
          Office ID: {office.officeMlsId} | ID #{memberMlsId}
        </Typography>
        <Box className={classes.addressBlock}>
          {office.officeAddress1 && (
            <Typography variant="body1">{office.officeAddress1}</Typography>
          )}
          <Typography variant="body1">
            {office.officeCity}, {office.officeStateOrProvince.displayValue}{' '}
            {office.officePostalCode}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          className={classes.selectButton}
          onClick={() => onSelect(memberMlsId)}
        >
          Select Account
        </Button>
      </CardContent>
    </Card>
  )
}

export default AccountCard
